// extracted by mini-css-extract-plugin
export default {"ClickBubble":"ClickBubble_ClickBubble__ZlAMn","fadeOut":"ClickBubble_fadeOut__qrA6Y"};